import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import { COMING_SOON } from '../helpers/availabilityTypes';

import Button from '../../../Button';

import { button, subtitle, title } from '../styles.module.css';

/**
 * Presentation component for Book Now without available tickets.
 */
const NotAvailable = ({
  availability, buttonLabel, permalink,
  ticketAvailableDate, titleLabel,
}) => (
  <div>
    <h2 className={title}>{titleLabel}</h2>
    {availability === COMING_SOON &&
      ticketAvailableDate && (
        <p className={subtitle}>{`Tickets go on sale on ${ticketAvailableDate}`}</p>
      )}
    <p className={subtitle}>
      {'You can view unavailable tickets '}
      <Link to={`${permalink}/tickets`} rel="nofollow">{'here'}</Link>
      {'.'}
    </p>
    <Button primary disabled className={button}>
      {buttonLabel}
    </Button>
  </div>
);

NotAvailable.propTypes = {
  availability: PropTypes.number.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  permalink: PropTypes.string.isRequired,
  ticketAvailableDate: PropTypes.string,
  titleLabel: PropTypes.string.isRequired,
};

NotAvailable.defaultProps = {
  ticketAvailableDate: undefined,
};

export default NotAvailable;



// WEBPACK FOOTER //
// ./app/src/components/EventHeader/BookNow/NotAvailable/index.jsx